import type { RouteRecordRaw } from "vue-router"

const Layout = () => import("@/layout/index.vue")
const ProcurementHome = () => import("@/views/page/procurement/procurementHome/index.vue")
const ConfirmOrder = () => import("@/views/page/procurement/order/confirmOrder/index.vue")
const OrderDetail = () => import("@/views/page/procurement/order/orderDetail/index.vue")
const Shoppingcart = () => import("@/views/page/procurement/shoppingcart/index.vue")
const Me = () => import("@/views/page/procurement/me/index.vue")
const ProductDetail = () => import("@/views/page/procurement/productDetail/index.vue")
const ProductSearch = () => import("@/views/page/procurement/productSearch/index.vue")
const OrderPayment = () => import("@/views/page/procurement/order/orderPayment/index.vue")

const procurement: RouteRecordRaw[] = [
  {
    path: "/procurement",
    component: Layout,
    redirect: "/procurement/home",
    meta: {
      hidden: true,
      order: 3,
      permissions: ["procurement"],
    },
    children: [
      {
        path: "home",
        component: ProcurementHome,
        name: "ProcurementHome",
        meta: {
          title: "采购",
          tagTitle: "首页",
          showTag: true,
          affix: true,
          svgIcon: "nav-procurement",
          permissions: ["procurement_all"],
        },
      },
      {
        path: "shoppingcart",
        component: Shoppingcart,
        name: "Shoppingcart",
        meta: {
          title: "采购车",
          showTag: true,
          hidden: true,
          affix: true,
          permissions: ["procurement_shoppingcart"],
        },
      },
      {
        path: "me",
        component: Me,
        name: "Me",
        meta: {
          title: "我的",
          showTag: true,
          hidden: true,
          affix: true,
          permissions: ["procurement_manage"],
        },
      },
      {
        path: "product_etail",
        component: ProductDetail,
        name: "ProductDetail",
        meta: {
          title: "商品详情",
          showTag: true,
          hidden: true,
          permissions: ["procurement_info"],
        },
      },
      {
        path: "product_search",
        component: ProductSearch,
        name: "ProductSearch",
        meta: {
          title: "商品搜索结果",
          showTag: false,
          hidden: true,
          permissions: ["procurement_info"],
        },
      },
      {
        path: "confirm_order",
        component: ConfirmOrder,
        name: "ConfirmOrder",
        meta: {
          title: "确认订单",
          showTag: true,
          hidden: true,
          permissions: ["procurement_order"],
        },
      },
      {
        path: "order_detail",
        component: OrderDetail,
        name: "OrderDetail",
        meta: {
          title: "订单详情",
          showTag: false,
          hidden: true,
          permissions: ["procurement_order"],
        },
      },
      {
        path: "orderPayment",
        component: OrderPayment,
        name: "OrderPayment",
        meta: {
          title: "支付",
          showTag: false,
          hidden: true,
          permissions: ["procurement_order"],
        },
      },
    ],
  },
]
export default procurement
